import React, { useState } from "react";
import ResetPasswordSection from "../../../components/ResetPasswordSection/ResetPasswordSection";
import { resetPassword } from "../logic/resetPasswordHelper";
import { useDispatch } from "react-redux";
import { setIsLoading } from "../../../features/userSlice";

const ResetPasswordScreen: React.FC = () => {
  const [email, setEmail] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const dispatch = useDispatch();

  const handleResetPassword = async () => {
    dispatch(setIsLoading(true));
    try {
      await resetPassword(email);
      setShowSuccessPopup(true);
      setEmail("");
    } catch (error: any) {
      setErrorPopupMessage(error.message);
      setShowErrorPopup(true);
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const handleCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
  };
  const handleCloseErrorPopup = () => {
    setShowErrorPopup(false);
  };

  return (
    <ResetPasswordSection
      email={email}
      onEmailChange={setEmail}
      onResetPasswordClick={handleResetPassword}
      showSuccessPopup={showSuccessPopup}
      showErrorPopup={showErrorPopup}
      onCloseSuccessPopup={handleCloseSuccessPopup}
      onCloseErrorPopup={handleCloseErrorPopup}
      errorPopupMessage={errorPopupMessage}
    />
  );
};

export default ResetPasswordScreen;
